import { render, staticRenderFns } from "./airSampleBox.vue?vue&type=template&id=67d92475&scoped=true"
import script from "./airSampleBox.vue?vue&type=script&lang=js"
export * from "./airSampleBox.vue?vue&type=script&lang=js"
import style0 from "./airSampleBox.vue?vue&type=style&index=0&id=67d92475&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d92475",
  null
  
)

export default component.exports